import axios from "axios";
import aesjs from "aes-js";

export default (async () => {
    const isProd = process.env.MIX_APP_ENV === 'production';
    const path = isProd ? '/revision.log' : '/creds.json';

    const res = await axios.get(path);
    let data = res.data;

    if (isProd) {
        data = data.trim();
        const key = [14, 67, 24, 60, 47, 81, 48, 98, 38, 79, 97, 93, 29, 16, 15, 55];
        const iv = [84, 92, 57, 83, 28, 84, 74, 26, 65, 52, 94, 86, 88, 71, 25, 16];

        const aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
        const bytes = aesjs.utils.hex.toBytes(data);
        const decryptedBytes = aesCbc.decrypt(bytes);

        data = JSON.parse(aesjs.utils.utf8.fromBytes(decryptedBytes));
    }

    return new CredManager(data);
})();

class CredManager {
    constructor(data) {
        this.credMgrData = data
    }

    get(key) {
        return this.credMgrData[key]
    }

    pusherApiKey() {
        return this.get('pusher-api-key');
    }
    pusherCluster() {
        return this.get('pusher-cluster');
    }
    bugsnagApiKey(){
        return this.get('bugsnag-api-key');
    }
}
